import { render, staticRenderFns } from "./RefsCompanyGroup.vue?vue&type=template&id=926faf44&scoped=true"
import script from "./RefsCompanyGroup.vue?vue&type=script&lang=ts"
export * from "./RefsCompanyGroup.vue?vue&type=script&lang=ts"
import style0 from "./RefsCompanyGroup.vue?vue&type=style&index=0&id=926faf44&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926faf44",
  null
  
)

export default component.exports